import { render, staticRenderFns } from "./CandidatesCopy.vue?vue&type=template&id=f6e98970&scoped=true&lang=pug"
import script from "./CandidatesCopy.vue?vue&type=script&lang=js"
export * from "./CandidatesCopy.vue?vue&type=script&lang=js"
import style0 from "./CandidatesCopy.vue?vue&type=style&index=0&id=f6e98970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e98970",
  null
  
)

export default component.exports